export const hexToRGBArray = (hex: string, alpha?: number): [number, number, number, number] => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    const a = 255 * (alpha < 1 ? alpha : 1);

    return [r, g, b, a];
  } else {
    return [r, g, b, 255];
  }
};
